import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.207 1.507 9 3.714v2.554l2.212-1.277.808-3.015 1.931.518-.656 2.449 2.45.656-.518 1.932-3.015-.808L10 8l2.212 1.277 3.015-.808.517 1.932-2.449.656.656 2.45-1.931.517-.808-3.015L9 9.732v2.554l2.207 2.207-1.414 1.414L8 14.114l-1.793 1.793-1.414-1.414L7 12.286V9.732L4.789 11.01l-.808 3.015-1.932-.518.656-2.449-2.45-.656.518-1.932 3.016.808L6 8 3.788 6.723l-3.015.808-.517-1.932 2.449-.656-.656-2.45 1.932-.517.808 3.015L7 6.268V3.714L4.793 1.507 6.207.093 8 1.886 9.793.093l1.414 1.414Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconComfortConditioner16 = createIcon(IconComponent);